// 带条件目标状态
import React from 'react'
import { connect } from 'react-redux'
import { nullDate, TDate } from '../../public/utility'
import { hasChangedValues } from '../../public/utility/formValues'
import { addListItem, changeListItem, deleteListItem, getMixedListValues, addListItemsFromListItems, resetListValues, isListValuesChanged, cloneListItem } from '../../public/utility'

class ProcessOperateTargetStatusDiv extends React.Component {
    state = {
        changedValues基本信息: {},
    }

    componentDidMount = () => {
        this.doGetProcessOperateTargetStatus(this.props.id)
    }
    componentWillUnmount = () => {
        this.unmount = true
    }
    doGetProcessOperateTargetStatus = (id) => {
        Tyan.doPostEvent({
            event: 'GetProcessOperateTargetStatus',
            data: { id, ProcessOperateID: this.props.ProcessOperateID },
            onEnd: ({ errorMessage, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {} })
                }
            }
        })
    }

    handlerSave = () => {
        const { ProcessOperateID, onRefresh, onClose } = this.props
        const { id, changedValues基本信息, initValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        Tyan.doPostEvent({
            event: 'SaveProcessOperateTargetStatus',
            data: { id, ProcessOperateID, changedValues基本信息: values },
            onEnd: ({ id, errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('保存成功')
                    onRefresh && onRefresh()
                    onClose && onClose()
                }
            }
        })
    }

    handlerDelete = () => {
        const { id } = this.state
        const { onRefresh, onClose } = this.props

        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteProcessOperateTargetStatus',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onRefresh && onRefresh()
                        onClose && onClose()
                    }
                }
            }))
    }

    handlerClose = () => {
        const { onRefresh, onClose } = this.props
        if (!this.bChanged()) {
            onRefresh && onRefresh()
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    bSave = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        return Object.keys(changedValues基本信息).length > 0 && values.目标状态 && values.条件
    }

    fieldset基本信息 = () => {
        return [
            { _text: '操作名称', disabled: true, minWidth: '95%' },
            { _text: '目标状态', required: true, minWidth: '95%' },
            { _text: '条件', required: true, minWidth: '95%' },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { errorMessage, id, initValues基本信息, changedValues基本信息 } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this} minWidth="800" maxWidth="1100"
            controls={
                [
                    { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.bSave(), },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
                ]}
        />
    }
}

export default connect()(ProcessOperateTargetStatusDiv)